import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    ChevronRight,
    ArrowLeft,
    User,
    ClipboardList,
    Truck,
    LogOut
} from "lucide-react";
import "./StateSelector.css";

const StateSelector = () => {
    const navigate = useNavigate();
    const [showAddVehicles, setShowAddVehicles] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

    const id = localStorage.getItem("userId");

    useEffect(() => {
      if (id && id.startsWith("VC-")) {
          setShowAddVehicles(true);   // vendor → show
      } else {
          setShowAddVehicles(false);  // customer → hide
      }
    }, [id]);

    const handleLogout = () => {
        // Temporary shared logout — works for both customer and vendor
        // accounts until the vendor interface gets its own redesign.
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login", { replace: true });
    };

    return (
        <div className="cp-settings font-satoshi">

            {/* ============ HEADER ============ */}
            <header className="cp-header cp-header--sub">
                <button
                    type="button"
                    className="cp-back-btn"
                    aria-label="Go back"
                    onClick={() => navigate(-1)}
                >
                    <ArrowLeft size={18} />
                </button>
                <div className="cp-header-title">Settings</div>
            </header>

            <div className="cp-settings-body">

                {/* ============ ACCOUNT ============ */}
                <div className="service-heading">
                    <p>Account</p>
                </div>

                <div className="cp-settings-list">
                    <div
                        className="cp-settings-row"
                        onClick={() => navigate("/user-profile-details")}
                    >
                        <div className="cp-settings-row-left">
                            <span className="cp-settings-icon"><User size={16} /></span>
                            Profile
                        </div>
                        <ChevronRight size={16} className="cp-settings-chevron" />
                    </div>

                    <div
                        className="cp-settings-row"
                        onClick={() => navigate("/crane-user-all-cases")}
                    >
                        <div className="cp-settings-row-left">
                            <span className="cp-settings-icon"><ClipboardList size={16} /></span>
                            View Order
                        </div>
                        <ChevronRight size={16} className="cp-settings-chevron" />
                    </div>

                    {showAddVehicles && (
                        <div
                            className="cp-settings-row"
                            onClick={() => navigate("/AllAddedVehiclesNew")}
                        >
                            <div className="cp-settings-row-left">
                                <span className="cp-settings-icon"><Truck size={16} /></span>
                                Add Vehicles
                            </div>
                            <ChevronRight size={16} className="cp-settings-chevron" />
                        </div>
                    )}
                </div>

                {/* ============ SESSION ============ */}
                <div className="service-heading">
                    <p>Session</p>
                </div>

                <div className="cp-settings-list">
                    <div
                        className="cp-settings-row cp-settings-row--danger"
                        onClick={() => setShowLogoutConfirm(true)}
                    >
                        <div className="cp-settings-row-left">
                            <span className="cp-settings-icon cp-settings-icon--danger"><LogOut size={16} /></span>
                            Logout
                        </div>
                        <ChevronRight size={16} className="cp-settings-chevron cp-settings-chevron--danger" />
                    </div>
                </div>

            </div>

            {/* ============ LOGOUT CONFIRM SHEET ============ */}
            {showLogoutConfirm && (
                <div className="cp-confirm-overlay" onClick={() => setShowLogoutConfirm(false)}>
                    <div className="cp-confirm-sheet" onClick={(e) => e.stopPropagation()}>
                        <div className="cp-confirm-icon"><LogOut size={20} /></div>
                        <h4>Log out of ClaimPro?</h4>
                        <p>You'll need to sign in again to access your account.</p>
                        <div className="cp-confirm-actions">
                            <button
                                type="button"
                                className="cp-confirm-cancel"
                                onClick={() => setShowLogoutConfirm(false)}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="cp-confirm-logout"
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default StateSelector;